import React from "react";
import { Button } from "react-bootstrap";
import "./fillButton.css";

export const FillButton = ({ onClick, text, disabled, fillButtonClass }) => {
  return (
    <>
      <Button
        className={`fill-button ${fillButtonClass}`}
        onClick={onClick}
        disabled={disabled}
      >
        {text}
      </Button>
    </>
  );
};
